module.exports = __webpack_public_path__ + "img/hx_1.4e5c96fc.jpg";